/**
 * <DebugOnly> — wrapper that only renders its children when DEBUG mode is ON.
 *
 * Usage:
 *   <DebugOnly>
 *     <Button onClick={dangerousAction}>Resync Bókun</Button>
 *   </DebugOnly>
 *
 * The wrapper reactively updates when the flag changes (via useDebugMode).
 */
import React from 'react';
import useDebugMode from '../hooks/useDebugMode';

const DebugOnly = ({ children, fallback = null }) => {
  const { debugMode } = useDebugMode();
  if (!debugMode) return fallback;
  return <>{children}</>;
};

export default DebugOnly;
